import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]

import { computed } from 'vue';
import { useStore } from 'vuex';

import { months } from '@/helpers/months';
import { SourceType } from '@/models/sourceTypes.enum';
import { SourcesModel } from '@/models/sidebar/info.model';

const emptyString = ' ';


export default /*@__PURE__*/_defineComponent({
  __name: 'SourceTooltip',
  props: {
    sources: {},
    source: {}
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

const currentSource = computed(() => {
  return props.sources.find((source) => source._id === props.source);
});

const isEmpty = (source: string): boolean => {
  if (source === emptyString) {
    return true;
  }
  return false;
};

const publishYear = computed(() => {
  return currentSource.value ? currentSource.value.publishDate.substring(0, 4) : '';
});

const sanitize = (value: string | string[]): string => {
  const clean = (v: string) => v.includes('/') ? v.replace(/\//g, ' ') : v;

  if (Array.isArray(value)) {
    return value.map(clean).join(', ');
  }
  else {
    return clean(value);
  }
};

const formattedAccessDate = computed(() => {
  if (!currentSource.value) {
    return '';
  }

  const date = currentSource.value.accessDate;

  const day = date.substring(8, 10);
  const monthIndex = Number(date.substring(5, 7)) - 1;
  const year = date.substring(0, 4);

  return `${day} ${months[monthIndex]} ${year}`;
});

return (_ctx: any,_cache: any) => {
  return (currentSource.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["tool-tip", { 'dark-mode': _unref(store).state.dark }])
      }, [
        (currentSource.value.type === _unref(SourceType).book || currentSource.value.type === _unref(SourceType).journal)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(sanitize(currentSource.value.author)) + _toDisplayString(isEmpty(sanitize(currentSource.value.author)) ? "" : ".") + " ", 1),
              _createElementVNode("b", null, "\"" + _toDisplayString(sanitize(currentSource.value.title)) + "\"", 1),
              _createTextVNode(_toDisplayString(isEmpty(sanitize(currentSource.value.title)) ? "" : ",") + " ", 1),
              _createElementVNode("i", null, _toDisplayString(sanitize(currentSource.value.publisher)), 1),
              _createTextVNode(_toDisplayString(isEmpty(sanitize(currentSource.value.publisher)) ? "" : ",") + " " + _toDisplayString(publishYear.value) + ". ", 1)
            ], 64))
          : (currentSource.value.type === _unref(SourceType).newsPaper)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("b", null, "\"" + _toDisplayString(sanitize(currentSource.value.title)) + "\"", 1),
                _createTextVNode(_toDisplayString(isEmpty(sanitize(currentSource.value.title)) ? "" : ".") + " ", 1),
                _createElementVNode("i", null, _toDisplayString(sanitize(currentSource.value.publisher)), 1),
                _createTextVNode(_toDisplayString(isEmpty(sanitize(currentSource.value.publisher)) ? "" : ",") + " " + _toDisplayString(publishYear.value) + ". ", 1)
              ], 64))
            : (currentSource.value.type === _unref(SourceType).website)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("b", null, "\"" + _toDisplayString(sanitize(currentSource.value.title)) + "\"", 1),
                  _createTextVNode(", " + _toDisplayString(sanitize(currentSource.value.author)) + _toDisplayString(isEmpty(sanitize(currentSource.value.author)) ? "" : ",") + " " + _toDisplayString(sanitize(currentSource.value.publisher)) + _toDisplayString(isEmpty(sanitize(currentSource.value.publisher)) ? "" : ",") + " " + _toDisplayString(formattedAccessDate.value) + _toDisplayString(isEmpty(formattedAccessDate.value) ? "" : ","), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("a", {
                    href: currentSource.value.url,
                    target: "_blank"
                  }, _toDisplayString(sanitize(currentSource.value.url)), 9, _hoisted_1)
                ], 64))
              : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})